<ng-template ngFor let-dynamicHostModel [ngForOf]="dynamicModalList">
	<cv-dynamic-host [ngClass]="{'model-instantiated': dynamicHostModel.instantiated}"></cv-dynamic-host>
</ng-template>
